import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_LOGO = '/logo_new.png';

let cachedSettings = null;
let fetchedOnce = false;

function resolveLogoUrl(url) {
  if (!url) return DEFAULT_LOGO;
  if (url.startsWith('/api/')) return `${API_URL}${url}`;
  if (url.startsWith('http')) return url;
  return url;
}

const DEFAULT_SETTINGS = {
  logo_url: DEFAULT_LOGO,
  guest_browsing: true,
  notifications_enabled: true,
  messaging_enabled: true,
  reviews_enabled: true,
  wishlist_enabled: true,
  maintenance_mode: false,
  seller_country_selection: true,
  seller_variant_media: true,
  seller_coupons: true,
  seller_paid_ads: true,
  seller_closures: true,
};

export function usePlatformSettings() {
  const [settings, setSettings] = useState(cachedSettings || DEFAULT_SETTINGS);

  useEffect(() => {
    if (fetchedOnce && cachedSettings) {
      setSettings(cachedSettings);
      return;
    }
    fetchedOnce = true;
    axios.get(`${API_URL}/api/platform/settings`).then(res => {
      const data = res.data || {};
      const resolved = {
        ...DEFAULT_SETTINGS,
        ...data,
        logo_url: resolveLogoUrl(data.logo_url),
      };
      cachedSettings = resolved;
      setSettings(resolved);
    }).catch(() => {});
  }, []);

  return settings;
}

export function usePlatformLogo() {
  const settings = usePlatformSettings();
  return resolveLogoUrl(settings.logo_url);
}

// Force refetch settings (call after admin updates)
export function invalidatePlatformSettings() {
  cachedSettings = null;
  fetchedOnce = false;
}
